import React from 'react';
import './Select.scss';
import DropdownArrow from '../Icons/DropdownArrow';
import { COLORS } from '../../../constants/colors';

/**
 * Renders a select element
 * @param label
 * @param {('transparent'|'translucent')} type - the type of select element
 * @param {array} data - the options for the select element
 * @param {string} id - the input id
 * @param {function} onChange - the handler for the onChange
 * @param {function} fieldRef
 * @param {string} fieldName
 * @returns {JSX.Element}
 * @constructor
 */
const Select = ({
  label,
  type,
  data = [{ title: 'United States ($USD)', default: true }],
  id,
  onChange = null,
  fieldRef = null,
  fieldName = '',
}) => {
  const renderOptions = (options) =>
    options.map((opt, i) => (
      <option
        key={`select-option-${i}`}
        value={opt?.value || opt?.url || opt?.title}
        hidden={opt?.hidden}
        disabled={opt?.disabled}
      >
        {opt?.title}
      </option>
    ));
  const selectedOption = data.find((opt) => opt.default === true);

  return (
    <div className={`c-select body-2 ${type}`}>
      <label htmlFor={id}>{label}</label>
      <select
        id={id}
        defaultValue={selectedOption?.url || selectedOption?.title}
        onChange={onChange}
        ref={fieldRef}
        name={fieldName}
      >
        {renderOptions(data)}
      </select>
      <div className="c-select__dropdown-arrow">
        <DropdownArrow color={type === 'transparent' ? COLORS.white : COLORS.black} />
      </div>
    </div>
  );
};

export default Select;
